import { h, Fragment } from "preact";
import { useContext, useEffect, useMemo, useRef, useState } from "preact/hooks";
import TextInput from "../../../../../common/TextInput";
import { checkEmail } from "../../../../../../tools";
import { sendVerificationCode, checkVerificationCode } from "../../../hooks/useSendCode";

export default function OwnerStepBuy({ formContext, onNext }) {
  const { formData, props } = useContext(formContext);
  console.log(props);
  const { address, accountNumber } = formData;

  const phoneInputRef = useRef(null);
  const additionalPhoneInputRef = useRef(null);

  const [ownerData, setOwnerData] = useState({
    lastName: formData.lastName || props.person.lastName,
    firstName: formData.firstName || props.person.firstName,
    middleName: formData.middleName || props.person.middleName,
    phone: formData.phone || props.person.phone,
    smsCode: "",
    phoneVerified: formData.phoneVerified || false,
    additionalPhone: formData.additionalPhone || "",
    additionalSmsCode: "",
    additionalPhoneVerified: formData.additionalPhoneVerified || false,
    email: formData.email || props.person.email,
    removeAddress: formData.removeAddress || false,
  });

  const [token, setToken] = useState(null);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};
    if (!ownerData.lastName) newErrors.lastName = "Введите фамилию";
    if (!ownerData.firstName) newErrors.firstName = "Введите имя";
    if (!ownerData.phoneVerified)
      newErrors.phone = "Подтвердите номер";
    if (ownerData.email && !checkEmail(ownerData.email))
      newErrors.email = "Введите корректный email";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === "email" && value && !checkEmail(value)) {
      setErrors((prev) => ({ ...prev, email: "Введите корректный email" }));
    } else {
      setOwnerData((prev) => ({ ...prev, [id]: value }));
    }
    if (errors[id]) setErrors((prev) => ({ ...prev, [id]: "" }));
  };

  const sendSmsCode = (phoneType) => {
    if (!ownerData[phoneType].trim()) {
      setErrors((prev) => ({ ...prev, [phoneType]: "Введите номер телефона" }));
      return;
    }
    setErrors((prev) => ({ ...prev, [phoneType]: "" }));
    sendVerificationCode(ownerData[phoneType], setToken);
  };

  const verifySmsCode = (phoneType, codeType) => {
    if (token === null) return;
    
    let result = checkVerificationCode(ownerData[phoneType], ownerData[codeType], token)
    .then(response => {
       if (response === true) {
        setOwnerData((prev) => ({ ...prev, [phoneType + 'Verified']: true }));
        setErrors((prev) => ({ ...prev, [codeType]: "" }));
      } else {
        setErrors((prev) => ({ ...prev, [codeType]: "Неверный код" }));
      }
    });
  };

  const handleNext = () => {
    if (validateForm()) {
      onNext(ownerData);
    }
  };

  const isFormValid = useMemo(() => {
    return (
      ownerData.lastName &&
      ownerData.firstName &&
      ownerData.phoneVerified &&
      !Object.values(errors).some((error) => error)
    );
  }, [ownerData, errors]);

  console.log("isFormValid", isFormValid);

  useEffect(() => {
    if (phoneInputRef.current) {
      window
        .Inputmask({
          mask: "+7 (999) 999 9999",
          clearIncomplete: true,
          oncomplete: function (e) {
            setOwnerData((prev) => ({ ...prev, phone: e.target.value }));
          },
          onincomplete: function () {
            setOwnerData((prev) => ({ ...prev, phone: "" }));
          },
        })
        .mask(phoneInputRef.current);
    }
    if (additionalPhoneInputRef.current) {
      window
        .Inputmask({
          mask: "+7 (999) 999 9999",
          clearIncomplete: true,
          oncomplete: function (e) {
            setOwnerData((prev) => ({
              ...prev,
              additionalPhone: e.target.value,
            }));
          },
          onincomplete: function () {
            setOwnerData((prev) => ({ ...prev, additionalPhone: "" }));
          },
        })
        .mask(additionalPhoneInputRef.current);
    }
  }, []);

  return (
    <div className="owner-step">
      <div className="owner-info">
        <p>{address}</p>
        <span>ЛС {accountNumber}</span>
      </div>
      <h1>Введите данные нового собственника жилого помещения</h1>
      <div className="form">
        <div className="form__body">
          {["lastName", "firstName", "middleName"].map((field) => (
            <div className="form__fieldset" style={{ paddingTop: "0" }}>
              <TextInput
                key={field}
                name={
                  field === "lastName"
                    ? "Фамилия"
                    : field === "firstName"
                    ? "Имя"
                    : "Отчество (при наличии)"
                }
                isRequired={field !== "middleName"}
                inputProps={{
                  value: ownerData[field],
                  onChange: handleChange,
                  id: field,
                }}
                errors={errors[field]}
              />
            </div>
          ))}
          {["phone", "additionalPhone"].map((field) => (
            <div className="form__fieldset">
              <div key={field} className="form__item form__item_horizontal">
                <div className="relative">
                  <TextInput
                    name={`${
                      field === "phone"
                        ? "Контактный номер телефона"
                        : "Дополнительный номер телефона"
                    } (подтвердите кодом из СМС)`}
                    isRequired={field === "phone"}
                    inputProps={{
                      value: ownerData[field],
                      onChange: handleChange,
                      disabled: ownerData[`${field}Verified`],
                      id: field,
                      ref:
                        field === "phone"
                          ? phoneInputRef
                          : additionalPhoneInputRef,
                    }}
                    errors={errors[field]}
                  />
                  {ownerData[`${field}Verified`] && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <circle cx="10" cy="10" r="10" fill="#14BA11" />
                      <path
                        d="M5.33203 10.0013L8.66536 13.3346L15.332 6.66797"
                        stroke="white"
                        stroke-width="1.5"
                      />
                    </svg>
                  )}
                </div>
                {!ownerData[`${field}Verified`] && (
                  <Fragment>
                    <button
                      className="button-secondary button-secondary_border-gray"
                      onClick={(e) => {
                        e.preventDefault();
                        sendSmsCode(field);
                      }}
                    >
                      Отправить код
                    </button>
                    <div className="form-field-sms">
                      <TextInput
                        inputProps={{
                          value: ownerData[`${field}SmsCode`],
                          onChange: handleChange,
                          id: `${field}SmsCode`,
                          placeholder: "Код из СМС",
                        }}
                        errors={errors[`${field}SmsCode`]}
                      />
                    </div>
                    <button
                      className="button-primary button-primary_pdv_lg"
                      onClick={(e) => {
                        e.preventDefault();
                        verifySmsCode(`${field}`, `${field}SmsCode`);
                      }}
                      disabled={!ownerData[`${field}SmsCode`] || !token}
                    >
                      Подтвердить
                    </button>
                  </Fragment>
                )}
              </div>
            </div>
          ))}

          <div className="form__fieldset">
            <div className="form__item">
              <TextInput
                name="Электронная почта"
                inputProps={{
                  value: ownerData.email,
                  onChange: handleChange,
                  id: "email",
                }}
                errors={errors.email}
              />
            </div>
          </div>
        </div>

        {/* показываем все ошибки */}
        {Object.values(errors).map((error) => (
          <div className="form__error-text">{error}</div>
        ))}

        <button
          className="button-primary button-primary_pdv_lg form__submit-btn"
          onClick={handleNext}
          disabled={!isFormValid}
        >
          Сохранить изменения
        </button>
      </div>
    </div>
  );
}
